/* eslint-disable no-unused-vars */
// Firebase App (the core Firebase SDK) is always required and must be listed first
import "firebase/app";
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import 'jquery';
import 'popper.js';
import './index.scss';
import AtomSpinner from '@bit/bondz.react-epic-spinners.atom-spinner';
import './icons/favicon.ico';

const LazyHome = React.lazy(() => import('./components/home'))
const LazyAbout = React.lazy(() => import('./components/about'))
const LazyCodeNation = React.lazy(() => import('./components/codenation'))
const LazyVideos = React.lazy(() => import('./components/videos'))
const LazyImgRef = React.lazy(() => import('./components/ref'))
const LazyError = React.lazy(() => import('./components/error'))
const LazyMyJourney = React.lazy(() => import('./components/myjourney'))
const LazyAchievements = React.lazy(() => import('./components/achievements'))
const LazyRecipes = React.lazy(() => import('./components/recipes'))
const LazyDash = React.lazy(() => import('./components/dashboard'))



function IndexLinks() {
        return(
            <div>
                    <React.Suspense fallback={<AtomSpinner />}>
                        <Switch>
                            <Route path="/" component={LazyHome} exact />
                            <Route path="/about" component={LazyAbout} />
                            <Route path="/codenation" component={LazyCodeNation} />
                            <Route path="/videos" component={LazyVideos} />
                            <Route path="/ref" component={LazyImgRef} />
                            <Route path="/myjourney" component={LazyMyJourney} />
                            <Route path="/achievements" component={LazyAchievements} />
                            <Route path="/recipes" component={LazyRecipes} />
                            <Route path="/dashboard" component={LazyDash} />
                            <Route component={LazyError} />
                        </Switch>
                    </React.Suspense>
            </div>
                )
                        };

class Index extends Component {
    render() {
        return(
            <BrowserRouter
            basename={process.env.PUBLIC_URL}>
                <div>
                    <IndexLinks/>
                </div>
            </BrowserRouter>
        )
    }
}

ReactDOM.render((<Index />
    ), document.getElementById('root'));